import React from "react";
import { SearchCommonField } from "../inputs/common-field";
import { SubsectionWithCheckboxes } from "./subsection/checkboxes";

export const NatureSection = () => {
    return (
        <>
            <SubsectionWithCheckboxes
                label="What sports do you prefer to do?"
                name="natureSports"
            >
                <SearchCommonField name="nature.alpineSkiing" />
                <SearchCommonField name="nature.canyoning" />
                <SearchCommonField name="nature.easyNatureHiking" />
                <SearchCommonField name="nature.mountainBiking" />
                <SearchCommonField name="nature.mountainHiking" />
                <SearchCommonField name="nature.nordicSkiing" />
                <SearchCommonField name="nature.rafting" />
                <SearchCommonField name="nature.roadCycling" />
                <SearchCommonField name="nature.rockClimbing" />
            </SubsectionWithCheckboxes>
            <SubsectionWithCheckboxes
                label="What activities do you prefer to do?"
                name="natureActivities"
            >
                <SearchCommonField name="nature.animalsWatching" />
                <SearchCommonField name="nature.dolphinsAndWhales" />
                <SearchCommonField name="nature.hotSprings" />
                <SearchCommonField name="nature.jungleTrekking" />
                <SearchCommonField name="nature.nationalPark" />
                <SearchCommonField name="nature.peaksSummits" />
                <SearchCommonField name="nature.safari" />
                <SearchCommonField name="nature.volcanoTrekking" />
                <SearchCommonField name="nature.waterfalls" />
                <SearchCommonField name="nature.polarLights" />
            </SubsectionWithCheckboxes>
            <SubsectionWithCheckboxes
                label="What kinds of natural landscapes would you like to see?"
                name="natureLandscapes"
                noMarginBottom
            >
                <SearchCommonField name="landscapes.mountains" />
                <SearchCommonField name="landscapes.forests" />
                <SearchCommonField name="landscapes.tropicalForest" />
                <SearchCommonField name="landscapes.hills" />
                <SearchCommonField name="landscapes.lake" />
                <SearchCommonField name="landscapes.wildRiver" />
                <SearchCommonField name="landscapes.desert" />
                <SearchCommonField name="landscapes.volcano" />
                <SearchCommonField name="landscapes.untypicalLandscape" />
            </SubsectionWithCheckboxes>
        </>
    );
};
